<template>
  <v-main style="padding: 0;">
    <page-header
      title="사용자 관리"
      @searchBtn="searchUser"
      :custom-button-list="customButtonList"
      :useList="buttonUseList"
    />
    <v-card>
      <v-card-text>
        <v-layout class="pl-6 pr-6" justify-start align-center>
          <v-col cols="6" lg="2" class="py-0">
            <v-select
              class="fontSize9 mr-3"
              :items="selectItems"
              label="선택"
              item-text="name"
              item-value="value"
              dense
              outlined
              v-model="search_type"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="6" lg="4" class="py-0" hide-details="true" flat="true">
            <v-text-field
              v-model="search_word"
              @keyup.enter="searchUser"
              dense
              outlined
              hide-details
            />
          </v-col>
        </v-layout>
      </v-card-text>

      <v-dialog v-model="isLayer" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">사용자 정보</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="사용자 ID"
                    v-model="userInfo.user_id"
                    readonly
                    required
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field type="password" label="암호" v-model="userInfo.password" hide-details></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="성명" v-model="userInfo.kor_nm" hide-details></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="전화번호" v-model="userInfo.phone" hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-text-field label="이메일" v-model="userInfo.email_addr" hide-details></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  md="2"
                  class="d-flex align-center justify-center"
                  style="font-size: 18px"
                >@</v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-text-field label="도메인" v-model="userInfo.email_domain" hide-details></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    :items="groupList"
                    label="사용자 구분"
                    item-text="usergroup_title"
                    item-value="usergroup_id"
                    v-model="userInfo.usergroup_id"
                    @change="usergroupChange($event)"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-radio-group label="사용 여부" row v-model="userInfo.use_yn" hide-details>
                    <v-radio label="사용" value="Y"></v-radio>
                    <v-radio label="미사용" value="N"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" v-show="usergroup004">
                  <v-select
                    :items="as_companys"
                    item-text="description"
                    item-value="codevalue"
                    label="사용자 구분에 따른 회사선택"
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined dense color="blue darken-1" text @click="saveUserInfo">저장</v-btn>
            <v-btn outlined dense color="blue darken-1" text @click="closeLayer">취소</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card id="realgrid" ref="realgrid" class="mt-1 mb-5 w-full"></v-card>
    </v-card>
  </v-main>
</template>

<script>
import {
  getAllUsers,
  getUserDetail,
  setUserInfo,
  getUserGroup
} from '@/api/greenCommon/user'
import { getASCompany } from '@/api/greenCommon/commonCode'
import localStore from '@/utils/localStore'
import RealGridJS from 'realgrid/dist/main'
import PageHeader from '@/layout/components/PageHeader'

let dataProvider
let gridView

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      selectItems: [
        { name: '사용자명', value: 'user_nm' },
        { name: '사용자 ID', value: 'user_id' }
      ],
      customButtonList: [
        { id: 'searchBtn', text: '조회', icon: 'mdi-magnify' }
      ],
      buttonUseList: [],
      groupList: [],
      userList: [],
      user_id: '',
      search_type: 'user_nm',
      search_word: '',
      userInfo: {
        user_id: '',
        password: '',
        kor_nm: '',
        phone: '',
        email_addr: '',
        email_domain: '',
        use_yn: ''
      },
      as_companys: [],
      grid: {
        gridFields: [],
        gridColumns: [],
        gridOption: {},
        gridStyle: {}
      },
      isLayer: false,
      usergroup004: false
    }
  },
  mounted() {
    this.init_grid()
    // this.init_data()
    // 초기 데이터 로딩 안함
    // this.searchUser()
    this.getUserGroupId()
  },
  methods: {
    init_data() {
      // usergroup_id는 서버 세션에서 결정 - 클라이언트에서 전송하지 않음
      let params = {}
      getAllUsers(params).then(response => {
        this.userList = response
        dataProvider.fillJsonData(this.userList)
      })

      getASCompany().then(response => {
        this.as_companys = response
        // this.receipt.receipt_mst.as_company = this.as_companys[0].codevalue
      })
    },
    getUserGroupId() {
      getUserGroup().then(response => {
        this.groupList = response
        // dataProvider.fillJsonData(this.groupList
      })
    },
    searchUser() {
      // usergroup_id는 서버 세션에서 결정 - 클라이언트에서 전송하지 않음
      let params = {
        search_type: this.search_type,
        search_word: this.search_word
      }
      if ((this.$store.state.user.grp_auth || '') === 'usergroup004') {
        if (this.search_word.length < 2) {
          alert('2글자 이상 입력해주세요')
          return
        }
      }
      getAllUsers(params).then(response => {
        if (response.length === 0) {
          gridView.setDisplayOptions.showEmptyMessage = true
        } else {
          gridView.setDisplayOptions.showEmptyMessage = false
        }
        this.userList = response
        dataProvider.fillJsonData(this.userList)
        gridView.closeLoading()
      })
    },

    userDeteail() {
      let params = {
        user_id: this.user_id
      }
      console.log(params)
      getUserDetail(params).then(response => {
        this.userInfo = response
        if (this.userInfo.usergroup_id === 'usergroup004') {
          this.usergroup004 = true
        }

        this.isLayer = true
      })
    },
    usergroupChange(e) {
      if (e === 'usergroup004') {
        this.usergroup004 = true
      } else {
        this.usergroup004 = false
      }
    },
    saveUserInfo() {
      let params = {
        user_id: this.userInfo.user_id,
        kor_nm: this.userInfo.kor_nm,
        password: this.userInfo.password,
        phone: this.userInfo.phone,
        email: this.userInfo.email_addr + '@' + this.userInfo.email_domain,
        usergroup_id: this.userInfo.usergroup_id,
        use_yn: this.userInfo.use_yn
      }
      setUserInfo(params).then(response => {
        alert('저장되었습니다.')
        params = {}
        getAllUsers(params).then(response => {
          this.userList = response
          dataProvider.fillJsonData(this.userList)
          this.closeLayer()
        })
      })
    },
    closeLayer() {
      this.isLayer = false
      this.usergroup004 = false
      this.userInfo = {
        user_id: '',
        kor_nm: '',
        phone: '',
        email_addr: '',
        email_domain: ''
      }
    },
    init_grid() {
      const _self = this
      dataProvider = new RealGridJS.LocalDataProvider()
      gridView = new RealGridJS.GridView('realgrid')
      gridView.setDataSource(dataProvider)
      // gridView.showLoading()
      gridView.setOptions(this.grid.gridOption)
      // gridView.setStyles(this.grid.gridStyle)

      let fields = [
        { fieldName: 'kor_nm', dataType: 'string' },
        { fieldName: 'user_id', dataType: 'string' },
        { fieldName: 'email', dataType: 'string' },
        { fieldName: 'phone', dataType: 'string' },
        { fieldName: 'usergroup_title', dataType: 'string' }
      ]
      let columns = [
        {
          name: 'kor_nm',
          fieldName: 'kor_nm',
          header: { text: '사용자명' },
          hoveredBackground: '#ccc',
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'user_id',
          fieldName: 'user_id',
          header: { text: '사용자ID' },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'email',
          fieldName: 'email',
          header: { text: '이메일' },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'phone',
          fieldName: 'phone',
          header: { text: '전화번호' },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'usergroup_title',
          fieldName: 'usergroup_title',
          header: { text: '사용자구분' },
          styles: {
            textAlignment: 'center'
          }
        }
      ]

      dataProvider.setFields(fields)
      gridView.setColumns(columns)
      // gridView.setSelectOptions({
      //   style: 'singleRow'
      // })
      gridView.setDisplayOptions({
        showEmptyMessage: false,
        emptyMessage: '조회된 데이터가 없습니다.'
      })
      gridView.onCellDblClicked = function(grid, clickData) {
        _self.user_id = dataProvider.getValue(clickData.dataRow, 'user_id')
        _self.userDeteail()
      }
      // gridView.onDataCellDblClicked = function(grid, index) {
      //   console.log('double click!', index)
      //   this.user_id = dataProvider.getValue(index.dataRow, 'user_id')
      //   this.userDeteail()
      // }.bind(this)
    }
  },
  created() {
    this.grid.gridOption = {
      panel: {
        visible: false
      },
      stateBar: {
        visible: false
      },
      checkBar: {
        visible: false
      },
      indicator: {
        visible: false
      },
      footer: {
        visible: false
      },
      edit: {
        // 데이터 편집
        appendable: false,
        insertable: false,
        deletable: false,
        readOnly: false,
        editable: false,
        updatable: false
      },
      header: {
        // gridView 헤더 설정
        height: 30,
        styles: {
          fontSize: '14',
          fontFamily: 'NanumGothic',
          foreground: '#fff',
          fontBold: 'false',
          background: '#5c97cd',
          selectedBackground: '#9bb2c7',
          borderLeft: '#fff',
          borderRight: '#fff'
        },
        selection: {
          background: '#efefef',
          border: '#ccc,1'
        }
      },
      display: {
        // 그리드 표시 정보 설정
        fitStyle: 'evenFill', // 컬럼 너비 자동 조절
        heightMeasurer: 'fixed',
        rowHeight: 30,
        focusVisible: false // 클릭시 포커스
      },
      sorting: {
        handleColor: '#fff', // 필터된 헤더 화살표 색상
        hoveredHandleColor: '#fff'
      },
      select: {
        style: 'row' // 선택시 스타일
      }
    }

    this.grid.gridStyle = {
      // gridView 스타일
      body: {
        fontSize: '14',
        fontFamily: 'NanumGothic',
        foreground: '#666',
        fontBold: 'false',
        borderLeft: '#fff,0',
        borderRight: '#ccc,1',
        borderBottom: '#ccc,1',
        empty: {
          textAlignment: 'center',
          lineAlignment: 'center',
          fontSize: 14,
          fontBold: false
        },
        dynamicStyles: [
          {
            criteria: '(row mod 2) = 0',
            styles: {
              background: '#F4F4FA'
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="less" scoped>
#realgrid {
  height: 650px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}
</style>
